module.exports = __webpack_public_path__ + "img/logo_cerfa.54cf557b.png";